import React, { useState } from 'react';

const parrotImage = '/parrot-pixel-logo.png';

const Header: React.FC = () => {
  const [imageError, setImageError] = useState(false);
  
  return (
    <header className="py-4 md:py-6 mb-4 md:mb-8 relative">
      <div className="flex items-center justify-center gap-2 md:gap-5">
        {!imageError ? (
          <img 
            src={parrotImage} 
            alt="Scacchi.ai Logo" 
            className="h-16 md:h-32 pointer-events-none"
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="h-16 w-16 md:h-32 md:w-32 flex items-center justify-center bg-dark-green text-terminal-green">
            🦜
          </div>
        )}
        <h1 className="font-press-start text-terminal-green text-xl sm:text-2xl md:text-4xl m-0">
          scacchi.ai
        </h1>
      </div>
    </header>
  );
};

export default Header;